/* eslint-disable no-use-before-define */

/* eslint-disable no-unused-vars */

/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import {
  Platform,
  Animated,
  StyleProp,
  ViewStyle,
  StyleSheet,
  View,
  TextStyle,
} from "react-native";
import SVG_Svg, {
  G as SVG_G,
  Path as SVG_Path,
  GProps,
  PathProps,
} from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: desc */

/***/

const Path = Animated.createAnimatedComponent<
  React.ComponentClass<
    PathProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_Path);
const G = Animated.createAnimatedComponent<
  React.ComponentClass<
    GProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_G);
const Svg = Animated.createAnimatedComponent(SVG_Svg);

/*
 * -------------------------------------------------------------------------
 *
 *  /$$$$$$                                /$$$$$$$  /$$
 * |_  $$_/                               | $$__  $$| $$
 *   | $$   /$$$$$$/$$$$   /$$$$$$        | $$  \ $$| $$ /$$   /$$  /$$$$$$
 *   | $$  | $$_  $$_  $$ /$$__  $$       | $$$$$$$ | $$| $$  | $$ /$$__  $$
 *   | $$  | $$ \ $$ \ $$| $$  \ $$       | $$__  $$| $$| $$  | $$| $$$$$$$$
 *   | $$  | $$ | $$ | $$| $$  | $$       | $$  \ $$| $$| $$  | $$| $$_____/
 *  /$$$$$$| $$ | $$ | $$| $$$$$$$/  /$$  | $$$$$$$/| $$|  $$$$$$/|  $$$$$$$
 * |______/|__/ |__/ |__/| $$____/  |__/  |_______/ |__/ \______/  \_______/
 *                       | $$
 *                       | $$
 *                       |__/
 *
 * -------------------------------------------------------------------------
 *
 * ORIGINAL SVG
 * ---------------------------------
 * <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none"> <desc id="IMP.BLUE">{"#WarningIcon":{"type":"SELECTOR","constraint":"xMinYMin meet","width":20,"height":18.28298568725586},"#WarningSVG":{"type":"SELECTOR","constraint":"none","width":20,"height":18.28298568725586},"#Vector":{"type":"SELECTOR","constraint":"none","width":2.0762109756469727,"height":6.541329383850098},"transforms":{"WarningSVG":[{"name":"WarningSVG","relativeTransforms":[[1,0,0],[0,1,0]],"rotation":0,"instanceParentName":"WarningSVG","isInstanceParent":true,"isInstanceChild":false,"width":20,"height":18.28298568725586}],"Vector":[{"name":"Vector","relativeTransforms":[[1,0,8.971919059753418],[0,1,12.8478364944458]],"rotation":0,"instanceParentName":"WarningSVG","isInstanceParent":false,"isInstanceChild":true,"width":2.0319108963012695,"height":2.055654525756836},{"name":"Vector","relativeTransforms":[[1,0,0],[0,1,0]],"rotation":0,"instanceParentName":"WarningSVG","isInstanceParent":false,"isInstanceChild":true,"width":20,"height":18.28298568725586},{"name":"Vector","relativeTransforms":[[1,0,8.951362609863281],[0,1,5.60347843170166]],"rotation":0,"instanceParentName":"WarningSVG","isInstanceParent":false,"isInstanceChild":true,"width":2.0762109756469727,"height":6.541329383850098}]}}</desc>
 * <g id="WarningIcon">
 * <g id="WarningSVG">
 * <path id="Vector" d="M9.99974 12.8478C9.44061 12.8478 8.97192 13.3165 8.97192 13.8756C8.97192 14.4347 9.44061 14.9034 9.99974 14.9034C10.5383 14.9034 11.0276 14.4347 11.0029 13.9003C11.0276 13.3124 10.563 12.8478 9.99974 12.8478Z" fill="#B48304"/>
 * <path id="Vector_2" d="M19.5133 16.4905C20.1588 15.3763 20.1629 14.0483 19.5215 12.9383L13.0832 1.78842C12.446 0.666032 11.2948 0 10.0039 0C8.71291 0 7.56174 0.670143 6.92449 1.78431L0.477959 12.9465C-0.163405 14.0689 -0.159294 15.4051 0.490293 16.5192C1.13166 17.6211 2.27871 18.283 3.56144 18.283H16.4216C17.7084 18.283 18.8637 17.6128 19.5133 16.4905ZM18.1155 15.6846C17.7578 16.3013 17.1246 16.6672 16.4175 16.6672H3.55733C2.85841 16.6672 2.22938 16.3096 1.87991 15.7052C1.52634 15.0926 1.52223 14.3608 1.8758 13.7441L8.32233 2.58601C8.67179 1.97343 9.29671 1.61163 10.0039 1.61163C10.7069 1.61163 11.3359 1.97754 11.6854 2.59012L18.1278 13.7482C18.4732 14.3485 18.469 15.0721 18.1155 15.6846Z" fill="#B48304"/>
 * <path id="Vector_3" d="M9.7449 5.63253C9.25565 5.77232 8.95142 6.21634 8.95142 6.75492C8.97608 7.07971 8.99664 7.40862 9.02131 7.73341C9.0912 8.97091 9.16109 10.1838 9.23098 11.4213C9.25565 11.8406 9.58045 12.1448 9.9998 12.1448C10.4192 12.1448 10.7481 11.8201 10.7686 11.3966C10.7686 11.1417 10.7686 10.9073 10.7933 10.6483C10.8385 9.85485 10.8878 9.06136 10.9331 8.26788C10.9577 7.75397 11.003 7.24005 11.0276 6.72614C11.0276 6.54113 11.003 6.37668 10.9331 6.21223C10.7234 5.75176 10.2341 5.51742 9.7449 5.63253Z" fill="#B48304"/>
 * </g>
 * </g>
 * </svg>
 *
 * ---------------------------------
 *
 * CONFIGURATION
 * ---------------------------------
 * {
 * 	"#WarningIcon": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 20,
 * 		"height": 18.28298568725586
 * 	},
 * 	"#WarningSVG": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 20,
 * 		"height": 18.28298568725586
 * 	},
 * 	"#Vector": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 2.0762109756469727,
 * 		"height": 6.541329383850098
 * 	},
 * 	"transforms": {
 * 		"WarningSVG": [
 * 			{
 * 				"name": "WarningSVG",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						0
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						0
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "WarningSVG",
 * 				"isInstanceParent": true,
 * 				"isInstanceChild": false,
 * 				"width": 20,
 * 				"height": 18.28298568725586
 * 			}
 * 		],
 * 		"Vector": [
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						8.971919059753418
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						12.8478364944458
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "WarningSVG",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 2.0319108963012695,
 * 				"height": 2.055654525756836
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						0
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						0
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "WarningSVG",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 20,
 * 				"height": 18.28298568725586
 * 			},
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						8.951362609863281
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						5.60347843170166
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "WarningSVG",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 2.0762109756469727,
 * 				"height": 6.541329383850098
 * 			}
 * 		]
 * 	}
 * }
 * ---------------------------------
 *
 * DESCRIPTION
 * ---------------------------------
 * No description provided!
 * ---------------------------------
 */

/** Component Properties Interface */
export type tProps = {
  style?: tStyle;
  svgStyle?: tStyle;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  onAnimationComplete?: () => void;
};
/***/

/***/

export type tStyle = StyleProp<ViewStyle>;
export type tTextStyle = StyleProp<TextStyle>;
/** Convenience for prop insertion from ast (no-color-literals/no-inline-styles) */

/* eslint-disable react-native/no-color-literals */

/* eslint-disable react-native/no-inline-styles */

/** Local Styles */

const kLocalStyles = StyleSheet.create({
  kOverlay: {
    left: 0,
    position: "absolute",
    top: 0,
  },
});
/***/

/***/

/**
 * Auto-Generated Imp.Blue Component based on your design!
 * @param {tProps} props Developer interface to the component!
 * @returns {JSX.Element} JSX
 *
 * Description --
 * No description provided!
 */

export const WarningIcon = (props: {
  style?: tStyle;
  svgStyle?: tStyle;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  onAnimationComplete?: () => void;
}): JSX.Element => {
  const {
    style = {
      width: 20,
      height: 19,
    },
    svgStyle = {
      width: "100%",
      height: "100%",
    },
    svgRef,
  } = props;
  /** Component Internal State */

  /** Component Internal Functions */

  /** Custom React-Hooks */

  /**
   * Custom hook to emulate onLayout events
   * (For use in web env only!)
   */
  /** End Custom React-Hooks */

  /** Component Render (Javascript-React Markup) */

  if (Platform.OS === "web") {
    return (
      <View style={style}>
        <Svg
          fill="none"
          id="svg_root"
          ref={svgRef}
          style={svgStyle}
          preserveAspectRatio="xMinYMin meet"
          viewBox="0 0 20 19"
        >
          <G id="WarningIcon">
            <Svg preserveAspectRatio="none" viewBox="0 0 20 19">
              <G id="WarningSVG">
                <Svg preserveAspectRatio="none" viewBox="0 0 20 19">
                  <Path
                    id="Vector"
                    d="M9.99974 12.8478C9.44061 12.8478 8.97192 13.3165 8.97192 13.8756C8.97192 14.4347 9.44061 14.9034 9.99974 14.9034C10.5383 14.9034 11.0276 14.4347 11.0029 13.9003C11.0276 13.3124 10.563 12.8478 9.99974 12.8478Z"
                    fill="#B48304"
                    strokeWidth="1"
                    vectorEffect="non-scaling-stroke"
                  />
                </Svg>
                <Path
                  id="Vector_2"
                  d="M19.5133 16.4905C20.1588 15.3763 20.1629 14.0483 19.5215 12.9383L13.0832 1.78842C12.446 0.666032 11.2948 0 10.0039 0C8.71291 0 7.56174 0.670143 6.92449 1.78431L0.477959 12.9465C-0.163405 14.0689 -0.159294 15.4051 0.490293 16.5192C1.13166 17.6211 2.27871 18.283 3.56144 18.283H16.4216C17.7084 18.283 18.8637 17.6128 19.5133 16.4905ZM18.1155 15.6846C17.7578 16.3013 17.1246 16.6672 16.4175 16.6672H3.55733C2.85841 16.6672 2.22938 16.3096 1.87991 15.7052C1.52634 15.0926 1.52223 14.3608 1.8758 13.7441L8.32233 2.58601C8.67179 1.97343 9.29671 1.61163 10.0039 1.61163C10.7069 1.61163 11.3359 1.97754 11.6854 2.59012L18.1278 13.7482C18.4732 14.3485 18.469 15.0721 18.1155 15.6846Z"
                  fill="#B48304"
                  strokeWidth="1"
                  vectorEffect="non-scaling-stroke"
                />
                <Path
                  id="Vector_3"
                  d="M9.7449 5.63253C9.25565 5.77232 8.95142 6.21634 8.95142 6.75492C8.97608 7.07971 8.99664 7.40862 9.02131 7.73341C9.0912 8.97091 9.16109 10.1838 9.23098 11.4213C9.25565 11.8406 9.58045 12.1448 9.9998 12.1448C10.4192 12.1448 10.7481 11.8201 10.7686 11.3966C10.7686 11.1417 10.7686 10.9073 10.7933 10.6483C10.8385 9.85485 10.8878 9.06136 10.9331 8.26788C10.9577 7.75397 11.003 7.24005 11.0276 6.72614C11.0276 6.54113 11.003 6.37668 10.9331 6.21223C10.7234 5.75176 10.2341 5.51742 9.7449 5.63253Z"
                  fill="#B48304"
                  strokeWidth="1"
                  vectorEffect="non-scaling-stroke"
                />
              </G>
            </Svg>
          </G>
        </Svg>
      </View>
    );
  }

  return (
    <View style={style}>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 20 19"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="Vector"
          d="M9.99974 12.8478C9.44061 12.8478 8.97192 13.3165 8.97192 13.8756C8.97192 14.4347 9.44061 14.9034 9.99974 14.9034C10.5383 14.9034 11.0276 14.4347 11.0029 13.9003C11.0276 13.3124 10.563 12.8478 9.99974 12.8478Z"
          fill="#B48304"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 20 19"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="Vector_2"
          d="M19.5133 16.4905C20.1588 15.3763 20.1629 14.0483 19.5215 12.9383L13.0832 1.78842C12.446 0.666032 11.2948 0 10.0039 0C8.71291 0 7.56174 0.670143 6.92449 1.78431L0.477959 12.9465C-0.163405 14.0689 -0.159294 15.4051 0.490293 16.5192C1.13166 17.6211 2.27871 18.283 3.56144 18.283H16.4216C17.7084 18.283 18.8637 17.6128 19.5133 16.4905ZM18.1155 15.6846C17.7578 16.3013 17.1246 16.6672 16.4175 16.6672H3.55733C2.85841 16.6672 2.22938 16.3096 1.87991 15.7052C1.52634 15.0926 1.52223 14.3608 1.8758 13.7441L8.32233 2.58601C8.67179 1.97343 9.29671 1.61163 10.0039 1.61163C10.7069 1.61163 11.3359 1.97754 11.6854 2.59012L18.1278 13.7482C18.4732 14.3485 18.469 15.0721 18.1155 15.6846Z"
          fill="#B48304"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 20 19"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="Vector_3"
          d="M9.7449 5.63253C9.25565 5.77232 8.95142 6.21634 8.95142 6.75492C8.97608 7.07971 8.99664 7.40862 9.02131 7.73341C9.0912 8.97091 9.16109 10.1838 9.23098 11.4213C9.25565 11.8406 9.58045 12.1448 9.9998 12.1448C10.4192 12.1448 10.7481 11.8201 10.7686 11.3966C10.7686 11.1417 10.7686 10.9073 10.7933 10.6483C10.8385 9.85485 10.8878 9.06136 10.9331 8.26788C10.9577 7.75397 11.003 7.24005 11.0276 6.72614C11.0276 6.54113 11.003 6.37668 10.9331 6.21223C10.7234 5.75176 10.2341 5.51742 9.7449 5.63253Z"
          fill="#B48304"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </Svg>
    </View>
  );
};
/***/

export default React.memo(WarningIcon);
